/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebGetMapDataModel,
  IWebGetMapDataRequest,
  IMappers,
  IWebGetMapDataResponse,
  IWebGetMapDataResponseError,
  TWebGetMapDataResponse,
} from './types';

const defaultConfig: TWebGetMapDataModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'favorites',
  pathApi: '/v1/web/get-map-data/',
  hostType: 'api',
} as TWebGetMapDataModel;

function createWebGetMapDataModel(parameters: IWebGetMapDataRequest): TWebGetMapDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebGetMapDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebGetMapDataRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebGetMapData<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebGetMapDataOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TWebGetMapDataResponse> {
  const { response, statusCode } = await httpApi.fetch(createWebGetMapDataModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebGetMapDataResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebGetMapDataResponseError);
    }
  }

  return { response, statusCode } as TWebGetMapDataResponse;
}

export { defaultConfig, createWebGetMapDataModel, fetchWebGetMapData };
